export default "__VITE_ASSET__BdejwKZL__"